import React from 'react';
import {
  Text,
  Box,
  HStack,
  VStack,
  Icon,
} from '@gluestack-ui/themed';
import { InfoIcon } from 'lucide-react-native';

interface DimensionHeaderProps {
  dimensionName: string;
  dimensionLabel: string;
  dimensionColor: string;
  totalPoints: number;
}

/**
 * DimensionHeader component displays the header for a rubric dimension
 */
const DimensionHeader: React.FC<DimensionHeaderProps> = ({
  dimensionName,
  dimensionLabel,
  dimensionColor,
  totalPoints,
}) => (
  <HStack alignItems="center" justifyContent="space-between" bg="$bgSubtle" p="$2" px="$3" borderRadius="$md">
    <HStack alignItems="center" space="sm">
      <Box bg={dimensionColor} p="$1" borderRadius="$sm">
        <Icon as={InfoIcon} size="xs" color="$textInverted" />
      </Box>
      <VStack>
        <Text size="2xs" color="$textSubtle" fontWeight="bold" textTransform="uppercase">
          {dimensionName}
        </Text>
        <Text size="sm" color="$textHeading" fontWeight="bold">
          {dimensionLabel}
        </Text>
      </VStack>
    </HStack>

    <Box bg="$bgApp" px="$3" py="$1" borderRadius="$full" borderWidth={1} borderColor="$borderLight">
      <Text size="xs" fontWeight="bold" color="$textHeading">
        {totalPoints}
        {' '}
        pts
      </Text>
    </Box>
  </HStack>
);

export default DimensionHeader;
